import { PageSection } from '@/components/common/PageSection';
import { SectionHeading } from '@/components/common/SectionHeading';
import { Deliverables } from '@/pages/Home/data';

const SectionId = 'deliverables';
const TitleId = 'deliverables-title';

export function DeliverablesSection() {
  return (
    <PageSection id={SectionId} titleId={TitleId} tone="pad">
      <div className="grid gap-12 lg:grid-cols-12 lg:items-start lg:gap-16">
        <div className="lg:col-span-5">
          <SectionHeading id={TitleId} title={Deliverables.title} description={Deliverables.description} />
          <p className="mt-6 max-w-xl leading-relaxed text-steel">{Deliverables.note}</p>
        </div>
        <div className="overflow-hidden rounded-lg border border-grid bg-paper lg:col-span-7">
          <h3 className="border-b border-grid px-5 py-4 font-bold text-graphite sm:px-6">{Deliverables.packageTitle}</h3>
          <ol className="divide-y divide-grid">
            {Deliverables.contents.map((packageItem, packageIndex) => (
              <li key={packageItem.title} className="flex gap-4 px-5 py-4 sm:px-6">
                <span aria-hidden="true" className="w-5 shrink-0 font-bold tabular-nums text-redline">
                  {packageIndex + 1}
                </span>
                <div>
                  <p className="font-semibold text-graphite">{packageItem.title}</p>
                  <p className="mt-0.5 text-[0.9375rem] leading-relaxed text-steel">{packageItem.detail}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </PageSection>
  );
}